import * as React from 'react';

const SvgImport = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 12.771V4H11V12.775L8.16452 10.2527L6.83548 11.7473L11.9978 16.3379L17.1641 11.7488L15.8359 10.2535L13 12.771ZM19 20V18H5V20H19Z", fill: "currentColor" }));

export { SvgImport as default };
